import React from "react";
import { DateRange } from "react-day-picker";
import { HotelFilterPopover } from "./HotelFilterPopover";
import { DateFilterPopover } from "./DateFilterPopover";
import { ExportFilterPopover } from "./ExportFilterPopover";

type HotelOption = {
  id: string;
  name: string;
  logoId?: string | null;
  logoClassName: string;
  logoLetter: string;
};

type GuesteriaPartnersRevenueFiltersProps = {
  hotelOptions: HotelOption[];
  selectedHotels: string[];
  dateRange?: DateRange;
  selectedExportFormat: "CSV" | "Excel" | null;
  onHotelsApply: (hotels: string[]) => void;
  onDateApply: (range: DateRange | undefined) => void;
  onExportApply: (format: "CSV" | "Excel" | null) => void;
  canExport: boolean;
};

export const GuesteriaPartnersRevenueFilters = ({
  hotelOptions,
  selectedHotels,
  dateRange,
  selectedExportFormat,
  onHotelsApply,
  onDateApply,
  onExportApply,
  canExport,
}: GuesteriaPartnersRevenueFiltersProps): React.JSX.Element => {
  return (
    <div className="flex items-center justify-between rounded-md bg-white py-2">
      <div className="flex items-center gap-2">
        <HotelFilterPopover
          options={hotelOptions}
          selectedHotels={selectedHotels}
          onApply={onHotelsApply}
        />
        <DateFilterPopover value={dateRange} onApply={onDateApply} />
      </div>
      {canExport ? (
        <ExportFilterPopover
          selectedFormat={selectedExportFormat}
          onApply={(format) => {
            onExportApply(format);
          }}
        />
      ) : null}
    </div>
  );
};
